import styled from '@emotion/styled';

export const ScrollerContent = styled.div`
    overflow-x: scroll;
    width: 100%;
    overflow-y: hidden;
`;

export const Wrapper = styled.div`
    position: relative;
`;

export const Shadow = styled.div`
    box-shadow: inset -95px 0px 85px -69px ${(p) => p.theme.color.black};
    position: absolute;
    pointer-events: none;

    width: 100%;
    height: 100%;

    z-index: 2;
`;

export const ScrollIcon = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    margin: 11px 3px;
    z-index: 3;
    cursor: pointer;
    &:hover,
    &:focus {
        svg {
            fill: ${(p) => p.theme.color.gray3};
        }
    }
`;
